<template>
  <div v-if="isVisible && hasErrorMessage" class="p-4 my-4 bg-red-100 border">
    <div class="flex">
      <div class="w-12 h-12">
        <i-heroicons-outline-exclamation-circle class="h-12 w-12 text-red-900" />
      </div>
      <span class="pt-3 pl-2 pr-12 text-2xl text-red-900" v-html="label" />
    </div>

    <p class="mb-2 ml-14 pr-12 text-lg text-red-900">
      <span v-if="messageIsHtml" v-html="parseMessage ? messageParsed : message" />
      <span v-else> {{ parseMessage ? messageParsed : message }}</span>
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

// Props with defaults
const props = withDefaults(
  defineProps<{
    label?: string;
    message?: string;
    parseMessage?: boolean;
    messageIsHtml?: boolean;
    isVisible?: boolean;
  }>(),
  {
    label: "Error",
    message: "",
    parseMessage: true,
    messageIsHtml: false,
    isVisible: false,
  }
);

let messageParsed = computed(() => {
  let msg = props.message.trim();
  try {
    let errorObj = JSON.parse(msg);

    let serverError = errorObj?.data?.errors?.Name[0];
    if (typeof serverError === "string") return serverError;

    serverError = errorObj?.data?.title;
    if (typeof serverError === "string") return serverError;

    serverError = errorObj?.title;
    if (typeof serverError === "string") return serverError;

    serverError = errorObj?.errors;
    if (serverError) return JSON.stringify(serverError);
  } catch (error) {
    //console.log("ErrorDisplay: " + error);
  }

  console.log("ErrorDisplay(text): " + msg);
  return msg.replaceAll(/^[\"']+|[\"']+$/g, ""); // trim quotes
});

let hasErrorMessage = computed(() => {
  return props.message && props.message.length > 0;
});
</script>
